import makeStyles from '@mui/styles/makeStyles';
import colors from '../styles/colors';

export const useStyles = makeStyles({
  fillHeight: {
    height: '100%',
  },
  otherTrades: {
    backgroundColor: colors.white,
  },
  blueThenClear: {
    background: `linear-gradient(top, ${colors.blue.l20} 0px 215px, rgba(0,0,0,0.0) 216px 100%)`,
  },
  filterContainer: {
    flexWrap: 'wrap',
  },
  faqContainer: {
    paddingBottom: '45px',
    backgroundColor: colors.white,
  },
});
